import { useTranslation } from 'react-i18next';
import { moneyFormat } from '@/lib/money';
import { UTILITY_RATE_CONFIRM_ABOVE_CENTS } from '@/lib/utilityRateCeiling';
import formStyles from '@/components/Form.module.css';
import styles from './HomeRateConfirmStep.module.css';

/**
 * The second step before a home rate above 40 cents per kWh saves (Warren, 21 October 2026, night: "Change: the Mcp
 * tool's cap and a homeowner's own rate cap go to 60 cents, like the rest."), in his words for every writer: "43.63
 * cents per kWh is above 40 cents. Confirm this rate." Confirm saves with confirm_above_40; Change it goes back to the
 * field. The Api asks the same when the flag is missing, so a stale page cannot skip it. Home Settings and the earn walk
 * show it; the copy is in the homeSettings namespace of every locale.
 */
export function HomeRateConfirmStep({ cents, currency, busy, onConfirm, onCancel }: {
  cents: number;
  /** The home's currency: "43.63¢" in USD, "CA$0.4363" in CAD. */
  currency?: string | null;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t, i18n } = useTranslation('homeSettings');
  const m = moneyFormat(currency, i18n.language);
  return (
    <div className={styles.step}>
      <p className={styles.text} role="alert">
        {t('rate.confirmAbove', { rate: m.compact(cents), threshold: m.compact(UTILITY_RATE_CONFIRM_ABOVE_CENTS) })}
      </p>
      <div className={styles.actions}>
        <button type="button" className={formStyles.btnPrimary} disabled={busy} onClick={onConfirm}>
          {t('rate.confirmRate')}
        </button>
        <button type="button" className={formStyles.btnSecondary} disabled={busy} onClick={onCancel}>
          {t('rate.confirmChange')}
        </button>
      </div>
    </div>
  );
}
